<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        :loading="loading"
        :title="title"
        extraLarge
        ref="Modal"
        @save="$refs.Tabs.handleSave()"
    >
        <rkm-alert
            color="info"
        >
            <div>
                <strong>Base Nacional:</strong>
                Utilize esta opção para pesquisar logradouros e CEPs oficiais disponíveis na base nacional.
            </div>

            <div class="mt-2">
                <strong>Base Local:</strong>
                Utilize esta opção para cadastrar ou localizar logradouros mantidos localmente pelo município/sistema.
            </div>
        </rkm-alert>

        <Tabs
            ref="Tabs"
            @exit="handleExit"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Tabs from './Tabs.vue'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Tabs },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    props: {
        disableFilters: { type: Boolean },
        title: { type: String, default: 'Não sei meu CEP' },
    },
    methods: {
        open() {

            this.$refs.Modal.show()
        },
        handleExit(logradouro) {
            this.$emit('select', logradouro)
            this.$refs.Modal.hide()
        },
    }
}
</script>